// extracted by mini-css-extract-plugin
export default {"back":"styles_back__2bi6C","noBorder":"styles_noBorder__hQ-Us","btnRight":"styles_btnRight__ZFitD"};